import type { PropertiesHyphen } from "csstype";
import type { Options as ControlOptions } from "ol/control/Control";
import Control from "ol/control/Control";

import hx from "../hydroxie";

/**
 * ContentControlの初期化オプションを表す型。
 */
export type ContentControlOptions = ControlOptions & {
    /** 要素に適用するスタイル(位置の調整などに使用) */
    style?: PropertiesHyphen;

    /** 表示する内容 */
    content: HTMLElement;
};

/**
 * 任意のコンテンツを表示するコントロール。
 */
export class ContentControl extends Control {
    constructor(options: ContentControlOptions) {
        const { style, content, target } = options;
        const element = options.element ?? hx("div", { className: "ol-content-control ol-control ol-unselectable" });
        element.append(content);

        super({ element, target });

        if (style) {
            for (const key of Object.keys(style) as (keyof typeof style)[]) {
                const value = style[key];
                if (value === null || typeof value === "string") {
                    element.style.setProperty(key, value);
                }
            }
        }
    }
}
